import { useCallback, useState } from 'react';
import { Text, Button } from 'components';
import { useLine } from 'hooks';
import { TEXT_STRING } from '../../constants';
import { toast } from 'react-toastify';

const LINE_ADD_FRIEND_PAGE_STR = TEXT_STRING.LINE.ADD_FRIEND_PAGE;

type TLineAddFriendProps = {
  onSuccess?: () => void;
  onClose: () => void;
};

function LineAddFriendModalContent({
  onSuccess,
  onClose,
}: TLineAddFriendProps) {
  const { goToAddLineBotAccount, mutateGetFriendStatus } = useLine();

  // State
  const [isConfirming, setIsConfirming] = useState(false);

  const handleAddLineFriend = useCallback(async () => {
    goToAddLineBotAccount(() => setIsConfirming(true));
  }, [goToAddLineBotAccount]);

  const handleConfirm = useCallback(async () => {
    const isLineFriend = await mutateGetFriendStatus();
    if (isLineFriend) {
      toast.success(TEXT_STRING.LINE.ADD_FRIEND_PAGE.SUCCESS);
      if (onSuccess) {
        onSuccess();
      }
    } else {
      toast.error(TEXT_STRING.LINE.ADD_FRIEND_PAGE.ERRORS.NOT_FRIEND_YET);
      setIsConfirming(false);
    }
  }, [mutateGetFriendStatus, onSuccess]);

  return (
    <div className="overflow-y-auto overflow-x-hidden max-h-[70vh] px-1 flex justify-center items-center">
      <div className="w-full max-w-md text-center">
        <Text fontSize={18} bold>
          {LINE_ADD_FRIEND_PAGE_STR.TITLE}
        </Text>

        <Text fontSize={14} textColor="text-neutral-500" className="mt-3">
          {LINE_ADD_FRIEND_PAGE_STR.DESCRIPTION}
        </Text>

        <div className="mt-6 flex flex-col gap-3">
          {isConfirming ? (
            <Button block onClick={handleConfirm}>
              {LINE_ADD_FRIEND_PAGE_STR.ACTIONS.CONFIRM}
            </Button>
          ) : (
            <>
              <Button block onClick={handleAddLineFriend}>
                {LINE_ADD_FRIEND_PAGE_STR.ACTIONS.OPEN_LINE}
              </Button>
              <Button
                block
                bgColor="bg-white"
                textColor="text-neutral-600"
                onClick={onClose}
              >
                {LINE_ADD_FRIEND_PAGE_STR.ACTIONS.BACK}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default LineAddFriendModalContent;
